const globalToggleBtn = document.getElementById("global-tag-toggle");
let showingFlavorNotes = true;
let currentMode = "flavor"; // options: 'flavor', 'bean', 'prep'

function renderTags(container, tags, color) {
  const output = container.querySelector(".tags-output");
  output.innerHTML = "";

  const tagValues = Array.isArray(tags) ? tags : Object.values(tags);

  tagValues.forEach((value) => {
    if (value && value.trim() !== "") {
      const tagEl = document.createElement("span");
      tagEl.classList.add("tag-badge");
      tagEl.textContent = value;

      // Apply dynamic color
      tagEl.style.borderColor = color;
      tagEl.style.backgroundColor = hexToRGBA(color, 0.04);

      output.appendChild(tagEl);
    }
  });
}

function hexToRGBA(hex, alpha) {
  if (!hex || !hex.startsWith("#")) return `rgba(0, 0, 0, ${alpha})`;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function updateAllCards() {
  const allTagLists = document.querySelectorAll(".card-product .tag-list");

  allTagLists.forEach((tagList) => {
    const tagsData = JSON.parse(tagList.dataset.tags);
    const color = tagsData.color || "#333333";

    let tagsToShow;

    if (currentMode === "flavor") {
      tagsToShow = tagsData.flavor_notes;
    } else if (currentMode === "bean") {
      tagsToShow = tagsData.bean_info;
    } else if (currentMode === "prep") {
      tagsToShow = tagsData.brew_method || {};
    }

    renderTags(tagList, tagsToShow, color);
  });
}

// Initial render
updateAllCards();
updateButtonStates();

// helper function
function updateButtonStates() {
  btnFlavor.classList.toggle("btn-primary", currentMode === "flavor");
  btnFlavor.classList.toggle("btn-outline", currentMode !== "flavor");

  btnBean.classList.toggle("btn-primary", currentMode === "bean");
  btnBean.classList.toggle("btn-outline", currentMode !== "bean");

  if (btnPrep) {
    btnPrep.classList.toggle("btn-primary", currentMode === "prep");
    btnPrep.classList.toggle("btn-outline", currentMode !== "prep");
  }
}
